//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../../../axios/axios.js'

import { decodeScheduleDayFields } from './CalendarUtils.js'
import WorkShiftSettings from './WorkShiftSettings.vue'

export default {
  components: {
    WorkShiftSettings
  },
  props: {
    additionalWorkShifts: {
      type: Array,
      default () {
        return []
      }
    },
    workShifts: {
      type: Array,
      default () {
        return []
      }
    },
    getPreviousWorkShift: {
      type: Function,
      default: () => {}
    },
    date: {
      type: Number,
      default: null
    },
    autoAssignToBrigadeDefault: {
      type: Boolean,
      default: false
    },
    office: {
      type: Boolean,
      default: false
    },
    overtimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    additionalOvertimeTariffs: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  methods: {
    onDeleteWorkShift: function (workShiftSettings) {
      this.deleteWorkShift(workShiftSettings)
      // this.$d_ask({
      //   callback: () => {
      //     this.deleteWorkShift(workShiftSettings)
      //   },
      //   header: 'Вы уверены, что хотите удалить дополнительную смену?'
      // })
    },
    deleteWorkShift: function (workShiftSettings) {
      if (!workShiftSettings) {
        return
      }

      const id = workShiftSettings.id
      const index = this.additionalWorkShifts.findIndex(ws => ws === workShiftSettings)

      if (id != null) {
        this.loading = true

        const bodyFormData = new FormData()
        bodyFormData.set('id', [id])

        axiosPost({
          url: '/service/delta/workday/delete',
          data: bodyFormData,
          onSuccess: () => {
            this.additionalWorkShifts.splice(index, 1)
            this.$emit('update')
          },
          onFailure: (response) => {
            this.$q.notify({
              type: 'negative',
              message: response.message || 'Ошибка при удалении дополнительной смены',
              progress: true,
              timeout: 8000
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.additionalWorkShifts.splice(index, 1)
      }
    },
    onAddWorkShift: function () {
      const additionalWorkShift = decodeScheduleDayFields({})
      additionalWorkShift.isAdditional = true

      this.additionalWorkShifts.push(additionalWorkShift)
    }
  }
}

